import { get, ref, set } from 'firebase/database'
import React, { useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { CardActions, Box } from '@mui/material'
import { MonopolyContext } from '../../contexts/MonopolyContext'

const CreateRoom = ({ ButtonElement }) => {
	const { db } = useContext(MonopolyContext),
		[loading, setLoading] = useState(false),
		generateRoomCode = _ => {
			return [0, 0, 0].map(_ => Math.floor(Math.random() * 10)).join('')
		},
		createRoom = _ => {
			setLoading(true)

			get(ref(db, 'lobbies')).then(ss => {
				let val = ss.val()

				if (val === null) {
					val = {}
				}

				let roomCode = generateRoomCode()
				for (let i = 0; i < 10000; i++) {
					if (val[roomCode]) {
						roomCode = generateRoomCode()
					}
				}

				set(ref(db, `lobbies/${roomCode}`), {
					roomExists: true,
				}).then(_ => {
					navigate(`game/${roomCode}`)

					setLoading(false)
				})
			})
		}
	let navigate = useNavigate()

	return (
		<CardActions>
			{/* <ButtonElement>Back</ButtonElement> */}
			<Box sx={{ flex: '1 1 auto' }}></Box>
			<ButtonElement
				loading={loading ? true : null}
				variant='text'
				onClick={createRoom}>
				Create Room
			</ButtonElement>
		</CardActions>
	)
}

export default CreateRoom
